import { useState } from "react";
import { Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../store/store";
import AuthAction from "../store/auth/action";

const SignIn = () => {
    const dispatch = useAppDispatch();
    const { isLoading, error } = useAppSelector(state => state.auth);

    const [email, setEmail] = useState<string>("");
    const [password, setPassword] = useState<string>("");

    const onSignInPress = () => {
        if (email && password) AuthAction.signIn(email, password, dispatch);
    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-[#f8f2ed] font-manrope">
            <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-sm">
                <h2 className="text-2xl font-semibold mb-6 text-center text-[#704e37]">Kyçuni</h2>

                <form>
                    <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="email">Email</label>
                        <input
                            className="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:ring-1 focus:ring-[#ebcaaa]"
                            id="email"
                            type="email"
                            placeholder="Email"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                        />
                    </div>

                    <div className="mb-6">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="password">Fjalëkalimi</label>
                        <input
                            className="appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-1 leading-tight focus:outline-none focus:ring-1 focus:ring-[#ebcaaa]"
                            id="password"
                            type="password"
                            placeholder="Fjalëkalimi"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                        />
                        {error && <label className="text-xs text-red-500 mt-1 block">{error}</label>}
                    </div>

                    <div className="flex flex-col gap-2">
                        <button
                            className="bg-[#704e37] text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring-1 focus:ring-[#ebcaaa] disabled:opacity-50"
                            type="button"
                            onClick={onSignInPress}
                            disabled={isLoading}
                        >
                            {isLoading ? "Prisni..." : "Kyçuni"}
                        </button>
                        <Link to="/forgot-password" className="text-center text-sm text-[#704e37]">Keni harruar fjalëkalimin?</Link>
                    </div>
                </form>

                <p className="text-center text-sm text-gray-600 mt-4">
                    Nuk keni llogari? <Link to="/signup" className="text-[#704e37] font-medium">Regjistrohuni</Link>
                </p>
            </div>
        </div>
    );
}

export default SignIn;
